const _ = require('lodash')
const env = require('./../../../.environment')

class LanguageHandler {
  localLanguage;
  constructor () {
    this.init()
  }

  init () {
    this.defaultLanguage()
  }r

  defaultLanguage () {
    let parser = window.location.pathname.split('/')
    this.localLanguage = localStorage.getItem('uiLanguage')
    if (parser[1]) {
      if (this.checkLanguage(parser[1])) {
        this.setLanguage(parser[1])
      } else if (this.localLanguage) {
        this.setLanguage(this.localLanguage)
      } else {
        if (!this.browserLanguage()) {
          this.setLanguage(env.DEFAULT_LANGUAGE)
        } else {
          this.setLanguage(this.browserLanguage())
        }
      }
    } else {
      if (this.localLanguage && this.checkLanguage(this.localLanguage)) {
        this.setLanguage(this.localLanguage)
        return
      }
      if (!this.browserLanguage) {
        this.setLanguage(env.DEFAULT_LANGUAGE)
      } else {
        this.setLanguage(this.browserLanguage())
      }
    }
  }

  browserLanguage () {
    let browserLang = navigator.language
    if (browserLang) {
      let lang = _.replace(browserLang, /((-[A-Z])\w*)/, '')
      if (this.checkLanguage(lang)) return lang
      return env.DEFAULT_LANGUAGE
    }
    return false
  }

  checkLanguage (lang) {
    return (_.indexOf(this.getSupportedLanguages(), lang) !== -1 || lang === env.DEFAULT_LANGUAGE)
  }

  setLanguage (language) {
    let supLangs = this.getSupportedLanguages()
    if (_.indexOf(supLangs, language) === -1) language = env.DEFAULT_LANGUAGE
    localStorage.setItem('uiLanguage', language)
  }

  getSupportedLanguages () {
    return env.SUPPORTED_LANGUAGES
  }

  getLanguage () {
    let supLangs = this.getSupportedLanguages()
    let storeLang = localStorage.getItem('uiLanguage')
    if (_.indexOf(supLangs, storeLang) === -1) return env.DEFAULT_LANGUAGE
    return localStorage.getItem('uiLanguage')
  }
}

export const LanguageService = new LanguageHandler()

export const LanguagePlugin = {
  install: function install (Vue) {
    Object.defineProperties(Vue.prototype, {
      $lang: {
        get () {
          return new LanguageHandler()
        }
      }
    })
  }
}



// WEBPACK FOOTER //
// ./src/services/LanguageHandler/index.js